import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import {
  USER_LOGIN_REQUEST,
  USER_LOGOUT,
  USER_LOGIN_FAIL,
  USER_GET_SESSION,
} from '../reducers/constants';
import { RootState } from '../store/store';
import { toast } from 'react-toastify';
import { LoginResponseData } from '@EHSNavigator/backend';

export const getSession =
  (
    userInfoFromStorage: LoginResponseData | null,
  ): ThunkAction<Promise<void>, RootState, unknown, AnyAction> =>
  async (
    dispatch: ThunkDispatch<RootState, unknown, AnyAction>,
  ): Promise<void> => {
    try {
      dispatch({
        type: USER_LOGIN_REQUEST,
      });
      dispatch({
        type: USER_GET_SESSION,
        payload: userInfoFromStorage,
      });
    } catch (error: any) {
      dispatch({
        type: USER_LOGIN_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const logout =
  (
    setUserInfo: (userInfo: LoginResponseData | null) => void,
  ): ThunkAction<Promise<void>, RootState, unknown, AnyAction> =>
  async (dispatch: ThunkDispatch<RootState, unknown, AnyAction>) => {
    try {
      setUserInfo(null);
      localStorage.removeItem('newEmail');
      toast.success('User logged out successfully');
      dispatch({ type: USER_LOGOUT });
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message;
      if (Array.isArray(errorMessage)) {
        errorMessage.forEach((msg: string) => toast.error(msg));
      } else {
        toast.error(errorMessage || 'An unexpected error occurred.');
      }
    }
  };
